// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__nOd6U","text":"SelectPayment_text__3Ritp","title":"SelectPayment_title__UaJZy","btn":"SelectPayment_btn__1CNKM"};